module.exports = __webpack_public_path__ + "img/bg-1.7a796d95.png";